import $ from 'jquery'
import ExamenPreviewResult from '@/views/consultations/en-cours/examen-para/examen-preview-result'

export default {
    name: 'registre',
    components: {
        ExamenPreviewResult
    },
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,

            liste_type_examens: [],
            fields: [
                'patient', 'sexe', 'date', { key: 'statut', label: 'Statut' }, 'interpretation', { key: 'action', label: 'Action.s' }
            ],
			filter: [],
			perPage: 25,
			currentPage: 1,

            filtre_resultat: '',

            result_preview: []
        }
    },
    computed: {
        registre_examen() {
            return this.$store.getters['registre_examen']
        },

        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },
    mounted() {
        this.$store.dispatch('getRegistreExamen', this.userCredentials.id).then(() => {
            if (this.registre_examen.length > 0) {
                this.is_empty = false

                let select_all = {
                    type_examen_id: 0,
                    type_examen: 'Tous'
                }
                this.liste_type_examens.push(select_all)
    
                this.registre_examen.forEach(element => {
                    let t = {
                        type_examen_id: element['type_examen_id'],
                        type_examen: element['type_examen']
                    }
                    this.liste_type_examens.push(t)
                });
            } else {
                this.is_empty = true
            }

            this.is_loading = false
        })
    },
    methods: {
        onFilterTarif() {
			let id_selected = this.filtre_resultat.type_examen_id
            
			if (id_selected > 0) {
                $('.shw-result').fadeOut(500)
				setTimeout(() => {
                    console.log("selected: ",id_selected)
					$('.result-exm-'+id_selected).fadeIn()
				}, 500);
			} else {
				$('.shw-result').fadeIn(500)
			}
		},

        previewResultExamen(demande_examen, data) {
            let demande = {
                type_examen_nom: demande_examen.type_examen,
                resultat: data.resultat,
                interpretation: data.interpretation
            }

            this.result_preview = demande
        },
    }
}


